export type SupportedLocales = 'nl' | 'en'
export const supportedLocales = ['nl', 'en']
export const defaultLocale = 'nl'

export default {
  supportLngs: supportedLocales,
  fallbackLng: defaultLocale,
  defaultNS: 'common',
  react: { useSuspense: false },
}

export function isSupportedLocale(locale: string): locale is SupportedLocales {
  return typeof locale === 'string' && supportedLocales.includes(locale)
}

export function getLocaleFromRequest(request: Request): SupportedLocales {
  const { pathname } = new URL(request.url)
  const [locale] = pathname.slice(1).split('/')
  return isSupportedLocale(locale) ? locale : defaultLocale
}

export function getAlternateLocale(locale: SupportedLocales) {
  return locale === 'nl'
    ? ('en' as SupportedLocales)
    : ('nl' as SupportedLocales)
}
